/* printSettingsPrintSection.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const printSettingsPrintSectionComponent = {
  template: require("./printSettingsPrintSection.html"),
  controllerAs: "vm",
  controller: class printSettingsPrintSectionController {
    /* @ngInject */
    constructor(
      commonService,
      printModuleService,
      expensesService,
      sessionDataService,
      $state
    ) {
      this.commonService = commonService;
      this.printModuleService = printModuleService;
      this.expensesService = expensesService;
      this.sessionDataService = sessionDataService;
      this.$state = $state;
    }
    $onInit() {
      this.expensesEnabled = this.expensesService.isEnabled(
        this.sessionDataService.user
      );
      this.printModuleService.expense = true;
    }
    async reset() {
      this.printModuleService.copies = 1;
      this.printModuleService.stapling = false;
      this.printModuleService.expense = true;
      await this.printModuleService.setDefaults();
      this.commonService.updateView();
    }
    switchToScan() {
      this.sessionDataService.lastOp = "main";
      this.$state.go("scan");
    }
    toggleStapling() {
      this.printModuleService.stapling = !this.printModuleService.stapling;
    }

    onChangeQuantity() {
      console.log(this.printModuleService.copies);
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/print/components/printSettingsPrintSection.component.js